import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutGLAssignmentList extends Layout {
    layoutheaderGLAList: LayoutHeader;
    sourceGlAssignment: DataSource;
    tableGLAssignment: Table;
}
